import { render, staticRenderFns } from "./RoleAddStore.vue?vue&type=template&id=fe4dcfe2"
import script from "./RoleAddStore.vue?vue&type=script&lang=js"
export * from "./RoleAddStore.vue?vue&type=script&lang=js"
import style0 from "./RoleAddStore.vue?vue&type=style&index=0&id=fe4dcfe2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports